<template>
  <main>
    <page-header></page-header>
    <router-view />
    <page-footer></page-footer>
  </main>
</template>

<script>
import PageHeader from './components/PageHeader.vue'
import PageFooter from './components/PageFooter.vue'
export default {
  components: { PageHeader, PageFooter },
}
</script>

<style lang="postcss">
main {
  @apply min-h-screen flex flex-col bg-white text-grey-darker;

  > section {
    @apply flex-grow;
  }
}
</style>